/*

 _      _       _    _                _
| |    (_)     | |  | |              | |
| |     _ _ __ | | _| |     ___   ___| | _____ _ __
| |    | | '_ \| |/ | |    / _ \ / __| |/ / _ | '__|
| |____| | | | |   <| |___| (_) | (__|   |  __| |
|______|_|_| |_|_|\_|______\___/ \___|_|\_\___|_|

=======================*============================

CategoryAccordions.js


*/

if (document.querySelector('ul#catslist')) {
  let categoryItems = document.querySelectorAll('ul#catslist li');
  let clickableLinks = document.querySelectorAll('ul#catslist li a');

  const toggleAccordion = (cat) => {
    let subCats = cat.children;
    for (subcat of subCats) {
      if (subcat.tagName === 'UL' && subcat.style.display !== 'block') {
        cat.querySelector('.category-chevron').style.transform =
          'rotate(180deg)';
        subcat.style.display = 'block';
      } else if (subcat.tagName === 'UL' && subcat.style.display === 'block') {
        cat.querySelector('.category-chevron').style.transform =
          'rotate(90deg)';
        subcat.style.display = 'none';
      }
    }
  };

  for (let cat of categoryItems) {
    let children = cat.children;
    for (child of children) {
      if (child.classList.contains('subcategory')) {
        cat.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          toggleAccordion(cat);
        });
      }
    }
  }

  for (let link of clickableLinks) {
    link.addEventListener('click', (event) => {
      event.stopPropagation();
      window.location.href = link.href;
    });
  }
}
